export default __webpack_public_path__ + "static/media/SHLL Colour RGB.6416f953.png";